import Container from '../../../components/container';
import KarinaLogo from '../../../assets/images/customers/karina-logo.png';
import AngelgresLogo from '../../../assets/images/customers/angelgres-logo.png';
import EngelLogo from '../../../assets/images/customers/engel-logo.png';
import FragnaniLogo from '../../../assets/images/customers/grupo-fragnani-logo.png';
import LefLogo from '../../../assets/images/customers/lef-logo.png';
import MohawkLogo from '../../../assets/images/customers/mohawk-logo.png';
import PamesaLogo from '../../../assets/images/customers/pamesa-logo.png';
import PisoforteLogo from '../../../assets/images/customers/pisoforte-logo.png';

export default function Customers() {
	const information: { qtt: string, title: string }[] = [
		{
			qtt: '+20',
			title: 'Clientes',
		},
		{
			qtt: '+100',
			title: 'Produtos vendidos',
		},
		{
			qtt: '10',
			title: 'Estados',
		}
	];

	return (
		<Container>
			<div className={'flex flex-wrap justify-center'}>
				<div className={'w-full flex justify-center text-3xl'}>Nossos Clientes</div>
				<div className={'bg-primary border-2 border-secondary w-56 my-3'}></div>
			</div>

			<div className={'w-full grid sm:grid-cols-4 grid-cols-2 py-2 gap-y-5 gap-6 justify-around'}>
				<img src={AngelgresLogo} alt={'Logo Karina Cerâmica'}
					className={'max-w-44 sm:max-w-44 md:max-w-56 mx-auto'}/>

				<img src={EngelLogo} alt={'Logo Karina Cerâmica'}
					className={'max-w-44 sm:max-w-44 md:max-w-56 mx-auto'}/>

				<img src={FragnaniLogo} alt={'Logo Karina Cerâmica'}
					className={'max-w-44 sm:max-w-44 md:max-w-56 mx-auto'}/>

				<img src={KarinaLogo} alt={'Logo Karina Cerâmica'}
					className={'max-w-44 sm:max-w-44 md:max-w-56 mx-auto'}/>

				<img src={LefLogo} alt={'Logo Karina Cerâmica'}
					className={'max-w-44 sm:max-w-44 md:max-w-56 mx-auto'}/>

				<img src={MohawkLogo} alt={'Logo Karina Cerâmica'}
					className={'max-w-44 sm:max-w-44 md:max-w-56 mx-auto'}/>

				<img src={PamesaLogo} alt={'Logo Karina Cerâmica'}
					className={'max-w-44 sm:max-w-44 md:max-w-56 mx-auto'}/>

				<img src={PisoforteLogo} alt={'Logo Karina Cerâmica'}
					className={'max-w-44 sm:max-w-44 md:max-w-56 mx-auto'}/>
			</div>

			<div
				className={'w-full grid grid-cols-1 sm:flex justify-around pt-6 sm:pt-6 text-2xl sm:text-3xl gap-y-10'}>
				{information.map((item, index) => (
					<div className={'col-span-1'} key={`${item.title}_${index}`}>
						<div className={'flex justify-center text-primary text-5xl sm:text-8xl'}>
							{item.qtt}
						</div>
						<div className={'flex justify-center'}>
							{item.title}
						</div>
					</div>
				))}
			</div>
		</Container>
	);
}